const NPI_ADDRESS_INFORMATION_KEY = "npiAddressInformation";
const WELCOME_EMAILS_UPDATE_DISMISSED = "welcomeEmailsUpdateDismissed";
const SKIP_CERTIFICATION_UPLOAD = "skipCertificationUpload";
const ONBOARDING_SUCCESS_KEY = "onboardingSuccess";
const ONBOARDING_SHIPPING_MODAL_SHOWN = "onboardingShippingModalShown";
const ACCOUNT_SETUP_MENU_TIME = "accountSetupMenuTime";
const CLASSIC_MIGRATION_MODAL_SHOWN = "classicMigrationModalShown";
const SEGMENTATION_QUESTIONS_COMPLETED = "segmentationQuestionsCompleted";
const BYPASS_INTERRUPT_SCREEN = "bypassInterruptScreen";

export {
  NPI_ADDRESS_INFORMATION_KEY,
  WELCOME_EMAILS_UPDATE_DISMISSED,
  SKIP_CERTIFICATION_UPLOAD,
  ONBOARDING_SUCCESS_KEY,
  ONBOARDING_SHIPPING_MODAL_SHOWN,
  ACCOUNT_SETUP_MENU_TIME,
  CLASSIC_MIGRATION_MODAL_SHOWN,
  SEGMENTATION_QUESTIONS_COMPLETED,
  BYPASS_INTERRUPT_SCREEN,
};
